export default {
  data() {
    return {
      gtmSubsection: '',
      gtmSubsection2: '',
      expCookieValue: this.$cookies.get('exp-jobs')
        ? this.$cookies.get('exp-jobs')
        : '',
      defaultDataLayer: {
        event: 'pageview',
        section: 'Hotmart Jobs',
        subsection: '',
        subsection2: '',
        language: this.$i18n.locale,
        logged: false,
      },
    }
  },

  methods: {
    gtmInit(subsection, subsection2, exp) {
      const hasExpCookieValue = !!exp
      if (hasExpCookieValue) {
        this.defaultDataLayer.exp = exp
      }
      this.defaultDataLayer.subsection = subsection
      this.defaultDataLayer.subsection2 = subsection2
      this.$gtm.init('GTM-M342BGM')
      this.$gtm.push({ ...this.defaultDataLayer })
    },
  },

  created() {
    this.gtmInit(this.gtmSubsection, this.gtmSubsection2, this.expCookieValue)
  },
}
